// src/services/debugLiff.js
class DebugLiffService {
  constructor() {
    this.isInitialized = false;
    this.debugToken = null;
    this.debugProfile = null;
  }

  async initialize(token = null) {
    if (token) {
      return this.initializeWithToken(token);
    }

    // 既存のトークンがある場合はそれを使用
    const storedToken = localStorage.getItem('debug_liff_token');
    if (storedToken) {
      return this.initializeWithToken(storedToken);
    }

    throw new Error('デバッグトークンが設定されていません');
  }

  async initializeWithToken(token) {
    try {
      // トークンの基本的な検証をスキップし、直接設定
      this.debugToken = token;
      this.debugProfile = {
        userId: 'debug-user-' + Date.now(),
        displayName: 'Debug User',
        pictureUrl: null,
        statusMessage: 'Debug mode user'
      };

      // ローカルストレージに保存
      localStorage.setItem('debug_liff_token', token);
      localStorage.setItem('debug_liff_profile', JSON.stringify(this.debugProfile));

      this.isInitialized = true;
      console.log('デバッグLIFF初期化完了:', this.debugProfile);

    } catch (error) {
      console.error('Debug LIFF initialization failed:', error);
      this.clearDebugData();
      throw error;
    }
  }

  getIDToken() {
    if (!this.isInitialized || !this.debugToken) {
      throw new Error('デバッグLIFFが初期化されていません');
    }
    return this.debugToken;
  }

  async getProfile() {
    if (!this.isInitialized || !this.debugProfile) {
      throw new Error('デバッグLIFFが初期化されていません');
    }
    return this.debugProfile;
  }

  logout() {
    this.clearDebugData();
    this.isInitialized = false;
  }

  login() {
    // デバッグモードでは何もしない
    console.log('デバッグモード: ログイン処理はスキップされます');
  }

  isInClient() {
    return false; // デバッグモードでは常にfalse
  }

  openWindow(url, external = false) {
    // デバッグモードでは新しいタブで開く
    window.open(url, '_blank');
  }

  closeWindow() {
    // デバッグモードでは何もしない
    console.log('デバッグモード: ウィンドウクローズはスキップされます');
  }

  get ready() {
    return this.isInitialized;
  }

  get version() {
    return 'debug-mode-1.0.0';
  }

  getDebugInfo() {
    return {
      isInitialized: this.isInitialized,
      hasDebugToken: !!this.debugToken,
      isLoggedIn: this.isInitialized,
      isInClient: false,
      version: this.version,
      profile: this.debugProfile,
      mode: 'debug',
      tokenPreview: this.debugToken ? this.debugToken.substring(0, 20) + '...' : null
    };
  }

  clearDebugData() {
    localStorage.removeItem('debug_liff_token');
    localStorage.removeItem('debug_liff_profile');
    this.debugToken = null;
    this.debugProfile = null;
  }

  // 既存の保存されたトークンがあるかチェック
  hasSavedToken() {
    return !!localStorage.getItem('debug_liff_token');
  }

  // 保存されたトークンで自動初期化を試行
  async tryAutoInitialize() {
    if (this.hasSavedToken()) {
      try {
        await this.initialize();
        return true;
      } catch (error) {
        console.warn('保存されたデバッグトークンでの自動初期化に失敗:', error);
        this.clearDebugData();
        return false;
      }
    }
    return false;
  }
}

const debugLiffService = new DebugLiffService();
export default debugLiffService;